import { type AppState } from '@auth0/auth0-react'

/**
 * Resolves where to send the user after Auth0 returns them from Universal Login.
 *
 * The interactive-login call sites capture the pre-login location into
 * `appState.returnTo`; this reads it back on the redirect callback. A valid
 * `returnTo` is an in-app relative URL (a single leading slash), which is
 * navigated to verbatim so query string and hash (Patients filters, the
 * Overview `?period=` window) survive the round-trip. Anything else (absent,
 * empty, or an absolute/protocol-relative URL that could point off-origin) falls
 * back to `/`, which re-runs `Bootstrap` and lands the session on its correct
 * default. `appState` round-trips through Auth0's own transaction state rather
 * than the inbound query string, so the absolute-URL rejection is defensive
 * rather than a guard against attacker-supplied input.
 */
export const resolveReturnTo = (appState?: AppState): string => {
  const returnTo = appState?.returnTo
  if (
    typeof returnTo === 'string' &&
    returnTo.startsWith('/') &&
    !returnTo.startsWith('//')
  ) {
    return returnTo
  }
  return '/'
}
